interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: string;
  align?: "left" | "center";
  className?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  intro,
  align = "left",
  className = "",
}: SectionHeadingProps) {
  const alignClasses =
    align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignClasses} ${className}`}>
      {eyebrow && (
        <div className="inline-flex items-center gap-2 mb-5 px-3.5 py-1.5 rounded-full bg-background-100/80 border border-background-200/60 text-[11px] uppercase tracking-[0.2em] text-foreground-700 font-medium">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
          {eyebrow}
        </div>
      )}
      <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-semibold tracking-tight text-foreground-950 max-w-3xl leading-[1.12]">
        {title}
      </h2>
      {intro && (
        <p className="mt-4 sm:mt-5 text-sm sm:text-base md:text-lg text-foreground-600 max-w-2xl leading-relaxed">
          {intro}
        </p>
      )}
    </div>
  );
}